import React from 'react'
import { Icon } from 'antd'

const lucideStyle = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.72,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

const MenuSvg = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-menu-icon lucide-menu'
    {...props}
  >
    <g {...lucideStyle}>
      <path d='M4 5h16' />
      <path d='M4 12h16' />
      <path d='M4 19h16' />
    </g>
  </svg>
)

const SettingSvg = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-settings-icon lucide-settings'
    {...props}
  >
    <g {...lucideStyle}>
      <path d='M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915' />
      <circle cx={12} cy={12} r={3} />
    </g>
  </svg>
)

const TruckSvg = (props) => (
  <svg viewBox='0 0 24 24' width='1em' height='1em' {...props}>
    <g {...lucideStyle}>
      <path d='M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2' />
      <path d='M15 18H9' />
      <path d='M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14' />
      <circle cx='17' cy='18' r='2' />
      <circle cx='7' cy='18' r='2' />
    </g>
  </svg>
)

const ShieldCheckSvg = (props) => (
  <svg viewBox='0 0 24 24' width='1em' height='1em' {...props}>
    <g {...lucideStyle}>
      <path d='M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z' />
      <path d='m9 12 2 2 4-4' />
    </g>
  </svg>
)

const FileTextSvg = (props) => (
  <svg viewBox='0 0 24 24' width='1em' height='1em' {...props}>
    <g {...lucideStyle}>
      <path d='M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z' />
      <path d='M14 2v5a1 1 0 0 0 1 1h5M8 13h2M14 13h2M8 17h2M14 17h2' />
    </g>
  </svg>
)

export const MenuIcon = (props) => <Icon component={MenuSvg} {...props} />
export const SettingIcon = (props) => <Icon component={SettingSvg} {...props} />
export const TruckIcon = (props) => <Icon component={TruckSvg} {...props} />
export const ShieldCheckIcon = (props) => (
  <Icon component={ShieldCheckSvg} {...props} />
)
export const FileTextIcon = (props) => (
  <Icon component={FileTextSvg} {...props} />
)
